import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect, useState } from 'react';

/**
 * Returns true when feature flags are ready to use.
 */
export const useFeatureFlagsReady = (): boolean => {
  const ldClient = useLDClient();
  const [featureFlagsReady, setFeatureFlagsReady] = useState(false);

  useEffect(() => {
    ldClient?.waitUntilReady().then(() => setFeatureFlagsReady(true));
  }, [ldClient]);

  return featureFlagsReady;
};
